import API_BASE_URL from "../config/api";

let refreshInterval = null;

export const startTokenRefresh = () => {
  // Clear any existing interval
  if (refreshInterval) {
    clearInterval(refreshInterval);
  }

  // Refresh every 25 minutes (1500000 ms)
  refreshInterval = setInterval(
    async () => {
      await refreshToken();
    },
    25 * 60 * 1000,
  );
};

export const stopTokenRefresh = () => {
  if (refreshInterval) {
    clearInterval(refreshInterval);
    refreshInterval = null;
  }
};

export const refreshToken = async () => {
  try {
    console.log("Attempting token refresh...");

    const response = await fetch(`${API_BASE_URL}/v1/auth/refresh`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      credentials: "include", // This sends cookies automatically
    });

    console.log("Refresh response status:", response.status);
    const data = await response.json();
    console.log("Refresh response data:", data);

    if (response.ok && data.access_token) {
      localStorage.setItem("access_token", data.access_token);
      console.log("Token refreshed silently ✅");
      return true;
    } else {
      console.log("Refresh failed:", data);
      return false;
    }
  } catch (err) {
    console.log("Token refresh error:", err);
    return false;
  }
};
